export enum EntityTypes {
  EntityName = 'EntityName',
  MEI = 'MEI',
  InstitutionType = 'InstitutionType',
  KycType = 'KycType',
  Address = 'Address',
  AddressLine2 = 'AddressLine2',
  City = 'City',
  State = 'State',
  PostalCode = 'PostalCode',
  Parent = 'Parent',
  ParentMEI = 'ParentMEI',
  FundManagerName = 'FundManagerName',
  FundManagerMEI = 'FundManagerMEI',
  LEI = 'LEI',
  CEI = 'CEI',
  NAICCode = 'NAICCode',
  CRN = 'CRN',
  EIN = 'EIN',
  GIIN = 'GIIN',
  InternalId = 'InternalId',
  EntityReference = 'EntityReference',
  UsTaxFormType = 'UsTaxFormType',
  TaxFormStatus = 'TaxFormStatus',
  KycStatus = 'KycStatus',
  CountryOfIncorporation = 'CountryOfIncorporation',
  CountryOfTaxResidence = 'CountryOfTaxResidence',
  CountryRegion = 'CountryRegion',
}

export enum EntityTypeHierarchy {
  HierarchyParent = 'HierarchyParent',
  HierarchyFundManager = 'HierarchyFundManager',
  HierarchyBoth = 'HierarchyBoth',
}

export type EntityTypeParams = {
  id?: string
  name: string
  mandatoryFields: EntityTypes[]
  hierarchy: EntityTypeHierarchy
  isActive: boolean
  agencyAdmin?: string
}
